<div class="container-scroller">
  <div class="d-flex">
    <div class="container-fluid page-body-wrapper">
      <app-sidebar *ngIf="showSidebar"></app-sidebar>
      <app-navbar *ngIf="showNavbar"></app-navbar>
      <!-- <app-settingsPanel *ngIf="showSettingsPanel"></app-settingsPanel> -->
      <div class="main-panel" [ngClass]="{ 'main-panel-only' : !showSidebar }">
        <div class="content-wrapper pb-0">
          <app-spinner *ngIf="isLoading"></app-spinner>
          <div contentAnimate *ngIf="!isLoading" class="h-100">
            <router-outlet></router-outlet>
          </div>
        </div>
        <app-footer *ngIf="showFooter"></app-footer>
        <!-- partial -->
      </div>
      <!-- main-panel ends -->
    </div>
  </div>

  <!-- page-body-wrapper ends -->
</div>